addEventListener('DOMContentLoaded', () => {
  const wishlistKey = 'wishlist';
  const countKey = 'user_wishlist_cnt';
  const ttlKey = 'wishlist_expires_at';
  const ttlMs = 7 * 24 * 60 * 60 * 1000;

  function readWishlist() {
    const expiresAt = Number(localStorage.getItem(ttlKey) || 0);

    if (expiresAt && Date.now() > expiresAt) {
      localStorage.removeItem(wishlistKey);
      localStorage.removeItem(countKey);
      localStorage.removeItem(ttlKey);
      return [];
    }

    try {
      const handles = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(handles) ? handles : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(handles) {
    const uniqueHandles = Array.from(new Set(handles.filter(Boolean)));
    localStorage.setItem(wishlistKey, JSON.stringify(uniqueHandles));
    localStorage.setItem(countKey, String(uniqueHandles.length));
    localStorage.setItem(ttlKey, String(Date.now() + ttlMs));
    return uniqueHandles;
  }

  function updateCounter(handles) {
    $('.wishlist-counter').text(String(handles.length));
  }

  function syncButtons(handles) {
    $('.wishlist').each(function () {
      const handle = $(this).attr('data-handle');
      const isActive = handles.includes(handle);

      $(this)
        .toggleClass('active-wishlist', isActive)
        .toggleClass('wishlist-custom-action', !isActive);
    });
  }

  let wishlist = writeWishlist(readWishlist());
  updateCounter(wishlist);
  syncButtons(wishlist);

  jQuery(document).on('click', '.wishlist-custom-action', function (event) {
    event.preventDefault();

    const handle = $(this).attr('data-handle');
    wishlist = writeWishlist([...readWishlist(), handle]);
    updateCounter(wishlist);
    syncButtons(wishlist);
  });

  jQuery(document).on('click', '.active-wishlist', function (event) {
    event.preventDefault();

    const handle = $(this).attr('data-handle');
    wishlist = writeWishlist(readWishlist().filter((item) => item !== handle));
    updateCounter(wishlist);
    syncButtons(wishlist);
  });
});
